export default {
  'meta': {
    'langName': 'VIETNAMESE',
    'lang': 'Tiếng Việt'
  },
  'title': 'THU HỒI SẢN PHẨM TRỤ BÓNG RỔ B900 TARMAK',
  'description': 'Nguy cơ rơi cột trụ rổ của sản phẩm trụ rổ bóng rổ B900 đã được xác định, nếu sử dụng mà không có tay cầm và đúng thao tác.\nVì sự an toàn của bạn, hãy dừng mọi hoạt động sử dụng nếu không lắp tay cầm điều chỉnh độ cao.\nBạn có thể bảo vệ sản phẩm của mình bằng một quy trình đơn giản và bộ dụng cụ sửa chữa sẽ được giao miễn phí cho bạn.\nTrang web dành riêng cho đợt thu hồi đang được xây dựng. Trang web sẽ hướng dẫn bạn các bước để thực hiện thao tác sử dụng sản phẩm một cách chi tiết. \nChúng tôi sẽ thông báo cho bạn ngay khi có (vào tháng 7).',
  'status': 'Translation validated by COUNTRY'
} as const
